import { useRef } from "react";
import { useAbm } from "../../../../services/abm";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { CloudUploadIcon } from "../../../icons";

export const SubirFichaActividad = ({params}) => {
  const inputRef = useRef(null);
  const actividades = useAbm({entity: "actividades"});
  const { loadDetails } = useAbmContext();

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (event) => {
    if(event.target.files.length === 0) return;

    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      actividades
        .create({
          ficha: {
            id: 0,
            nombre: file.name,
            contenido: reader.result,
            tipo: file.type,
          }
        }, `actividades/${params.id}/ficha`)
        .then(() => loadDetails(params.id));
    };

    reader.readAsDataURL(file);
    event.target.value = "";
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        style={{display: "none"}}
        onChange={handleFileChange}
      />
      <ActionButton
        iconButton
        enabled={true}
        Icon={CloudUploadIcon}
        onClick={handleClick}
      />
    </>
  );
};
